import { useCallback, useEffect, useState } from 'react';
import { expandTreeViewEventName } from '../alerts';

/**
 * Controlled TreeView expansion that also opens a node when scrollWithOffset asks for it,
 * so an error label can reveal a field inside a collapsed section before scrolling to it.
 */
export const useExpandableTreeView = (treeViewId: string, defaultExpanded: string[] = []) => {
  const [expanded, setExpanded] = useState<string[]>(defaultExpanded);

  useEffect(() => {
    const listener = (event: Event) => {
      const nodeId = (event as CustomEvent<{ nodeId: string }>).detail?.nodeId;
      if (!nodeId) return;
      setExpanded(current => (current.includes(nodeId) ? current : [...current, nodeId]));
    };
    const eventName = expandTreeViewEventName(treeViewId);
    window.addEventListener(eventName, listener);
    return () => window.removeEventListener(eventName, listener);
  }, [treeViewId]);

  const onNodeToggle = useCallback((_event: unknown, nodeIds: string[]) => setExpanded(nodeIds), []);

  return { expanded, onNodeToggle };
};
